import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

const app = createApp(App)
  .use(IonicVue)
  .use(router);

import { BrandingService } from '@/services/branding.service';

async function boot() {
  // 1. Carrega Branding ANTES de montar o app (evita flicker do logo padrão)
  try {
    const branding = await BrandingService.getBranding();
    if (branding) {
      BrandingService.applyBranding(branding);
    }
  } catch (e) {
    console.error('Erro no boot branding:', e);
  }

  // 2. Espera o router e monta o app
  await router.isReady();
  app.mount('#app');
}

boot();